import React, { useState, useEffect } from 'react';

type TimerProps = {
    className: string;
    secondsToStop: number;
    onComplete: () => void;
    isRunning: boolean;
};

const Timer: React.FC<TimerProps> = ({ className, secondsToStop, onComplete, isRunning }) => {
    const [timeLeft, setTimeLeft] = useState(secondsToStop);

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        if (isRunning) {
            setTimeLeft(secondsToStop); // Reset timer when isRunning is true
            interval = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev === 1) {
                        clearInterval(interval as NodeJS.Timeout);
                        onComplete();
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (interval) clearInterval(interval); // Cleanup on unmount or stop
        };
    }, [isRunning, secondsToStop, onComplete]);

    const formatTime = (seconds: number): string => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    const timerClassName = timeLeft <= 10 ? `${className} text-red-500` : className;

    return <div className={timerClassName}>{formatTime(timeLeft)}</div>;
};

export default Timer;
